// extracted by mini-css-extract-plugin
export default {"root":"tKBYI","title":"zcTOz","inner":"FZ1E9","actions":"OkjUx","img":"Nf4kd","readOnlyButton":"L2OlH","lessonResult":"EEjD0","icon":"GK2wm"};